import React from "react";

export const barChartSvg = {
  viewBox: "0 0 24 24",
  data: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 13C0 12.4477 0.447715 12 1 12H5C5.55228 12 6 12.4477 6 13V23C6 23.5523 5.55228 24 5 24H1C0.447715 24 0 23.5523 0 23V13Z"
        fill="#577EFF"
      />
      <path
        d="M18 7C18 6.44772 18.4477 6 19 6H23C23.5523 6 24 6.44772 24 7V23C24 23.5523 23.5523 24 23 24H19C18.4477 24 18 23.5523 18 23V7Z"
        fill="#577EFF"
      />
      <path
        d="M9 1C9 0.447716 9.44772 0 10 0H14C14.5523 0 15 0.447715 15 1V23C15 23.5523 14.5523 24 14 24H10C9.44772 24 9 23.5523 9 23V1Z"
        fill="#577EFF"
      />
    </svg>
  ),
};

export const lineChartSvg = {
  viewBox: "0 0 24 24",
  data: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8943 6.55278C24.1413 7.04676 23.9411 7.64744 23.4471 7.89443L16.4471 11.8944C16.2336 12.0012 15.9889 12.028 15.7574 11.9701L8.16957 10.0732L1.52989 14.848C1.06155 15.1407 0.444602 14.9983 0.151891 14.53C-0.140819 14.0617 0.00155425 13.4447 0.469891 13.152L7.46989 8.152C7.70014 8.00809 7.97901 7.964 8.24242 8.02986L15.8835 9.94014L22.5527 6.10557C23.0467 5.85858 23.6473 6.05881 23.8943 6.55278Z"
        fill="#F76368"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9701 2.75746C24.1041 3.29326 23.7783 3.83619 23.2425 3.97014L16.2425 5.97014C16.1228 6.00009 15.9985 6.00759 15.876 5.99228L8.06131 5.01545L1.24253 6.97014C0.706733 7.10409 0.163799 6.77833 0.0298499 6.24254C-0.104099 5.70674 0.221662 5.16381 0.757457 5.02986L7.75746 3.02986C7.87723 2.99991 8.00152 2.99241 8.12403 3.00772L15.9387 3.98455L22.7575 2.02986C23.2933 1.89591 23.8362 2.22167 23.9701 2.75746Z"
        fill="#FFC561"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7526 11.3415C24.1163 11.7571 24.0742 12.3889 23.6585 12.7526L16.6585 19.7526C16.3815 19.995 15.9936 20.0656 15.6489 19.9363L8.20863 17.1462L1.65852 23.7526C1.24288 24.1163 0.611119 24.0741 0.247437 23.6585C-0.116245 23.2429 -0.0741276 22.6111 0.341509 22.2474L7.34151 15.2474C7.61857 15.005 8.00643 14.9344 8.35114 15.0637L15.7914 17.8538L22.3415 11.2474C22.7571 10.8837 23.3889 10.9259 23.7526 11.3415Z"
        fill="#577EFF"
      />
    </svg>
  ),
};

export const stackBarSvg = {
  viewBox: "0 0 24 24",
  data: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 1C9 0.447715 9.44772 0 10 0H14C14.5523 0 15 0.447715 15 1V4H9V1Z" fill="#FFC561" />
      <path d="M18 7C18 6.44772 18.4477 6 19 6H23C23.5523 6 24 6.44772 24 7V9H18V7Z" fill="#FFC561" />
      <path d="M0 13C0 12.4477 0.447715 12 1 12H5C5.55228 12 6 12.4477 6 13V14H0V13Z" fill="#FFC561" />
      <path d="M9 4H15V11H9V4Z" fill="#F76368" />
      <path d="M18 9H24V14H18V9Z" fill="#F76368" />
      <path d="M0 14H6V17H0V14Z" fill="#F76368" />
      <path d="M9 11H15V23C15 23.5523 14.5523 24 14 24H10C9.44772 24 9 23.5523 9 23V11Z" fill="#577EFF" />
      <path d="M18 14H24V23C24 23.5523 23.5523 24 23 24H19C18.4477 24 18 23.5523 18 23V14Z" fill="#577EFF" />
      <path d="M0 17H6V23C6 23.5523 5.55228 24 5 24H1C0.447715 24 0 23.5523 0 23V17Z" fill="#577EFF" />
    </svg>
  ),
};

export const pieChartSvg = {
  viewBox: "0 0 24 24",
  data: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5336 0.0874869C12.9698 0.0153299 12.4951 0.473487 12.4951 1.04184V22.9582C12.4951 23.5265 12.9698 23.9847 13.5336 23.9125C19.4371 23.1569 24 18.1115 24 12C24 5.88846 19.4371 0.843102 13.5336 0.0874869Z"
        fill="#577EFF"
      />
      <path
        d="M1.04181 12.5004C0.473464 12.5004 0.0153095 12.975 0.0873776 13.5387C0.777995 18.9411 5.0563 23.2214 10.4563 23.9125C11.0201 23.9847 11.4947 23.5265 11.4947 22.9582V13.5004C11.4947 12.9481 11.047 12.5004 10.4947 12.5004H1.04181Z"
        fill="#F76368"
      />
      <path
        d="M11.4947 1.04184C11.4947 0.473486 11.0201 0.0153225 10.4563 0.0874751C5.0563 0.778596 0.777995 5.05887 0.0873776 10.4613C0.0153095 11.025 0.473465 11.4996 1.04181 11.4996H10.4947C11.047 11.4996 11.4947 11.0519 11.4947 10.4996V1.04184Z"
        fill="#FFC561"
      />
    </svg>
  ),
};

export const ringPieSvg = {
  viewBox: "0 0 24 24",
  data: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5384 23.9023C12.9747 23.9745 12.5 23.5163 12.5 22.948V18.9004C12.5 18.38 12.9026 17.9555 13.4086 17.8337C16.0427 17.2 18 14.8286 18 12C18 9.17144 16.0427 6.80002 13.4086 6.16628C12.9026 6.04455 12.5 5.62005 12.5 5.09964V1.05206C12.5 0.483705 12.9747 0.0255518 13.5384 0.0976977C19.4393 0.852856 24 5.89382 24 12C24 18.1062 19.4393 23.1472 13.5384 23.9023Z"
        fill="#577EFF"
      />
      <path
        d="M1.05208 12.5C0.483728 12.5 0.0255672 12.9746 0.0977088 13.5384C0.788372 18.9356 5.06448 23.2117 10.4617 23.9023C11.0255 23.9745 11.5 23.5163 11.5 22.948V18.9004C11.5 18.38 11.0973 17.9555 10.5914 17.8337C8.4091 17.3087 6.69136 15.591 6.16631 13.4087C6.04457 12.9027 5.62007 12.5 5.09966 12.5H1.05208Z"
        fill="#F76368"
      />
      <path
        d="M11.5 1.05208C11.5 0.483728 11.0255 0.0255672 10.4617 0.0977088C5.06448 0.788372 0.788372 5.06448 0.0977088 10.4617C0.0255672 11.0255 0.483729 11.5 1.05208 11.5H5.09966C5.62007 11.5 6.04457 11.0973 6.16631 10.5914C6.69136 8.4091 8.4091 6.69136 10.5914 6.16631C11.0973 6.04457 11.5 5.62007 11.5 5.09966V1.05208Z"
        fill="#FFC561"
      />
    </svg>
  ),
};

export const pieLimitError = {
  viewBox: "0 0 200 120",
  data: (
    <svg width="200" height="120" viewBox="0 0 200 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="200" height="120" rx="4" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M96.4667 15.6468C73.7619 21.7306 59.6102 44.1795 63.3777 66.9597C63.7385 69.1411 65.9336 70.4132 68.0675 69.8414L147.273 48.6182C149.407 48.0465 150.708 45.8378 149.973 43.7566C142.297 22.0236 119.171 9.56313 96.4667 15.6468Z"
        fill="#F0F3FF"
      />
      <path
        d="M85.077 95.9191C83.9166 97.787 84.4748 100.258 86.4294 101.266C94.886 105.625 104.72 107.37 114.616 105.733C116.797 105.372 118.069 103.177 117.497 101.043L107.365 63.2296C107.139 62.384 106.012 62.2171 105.55 62.9608L85.077 95.9191Z"
        fill="#E5EBFF"
      />
      <path
        d="M66.2259 89.9315C64.4142 91.1583 63.9105 93.6263 65.2678 95.3425C67.3611 97.9894 69.7757 100.431 72.4987 102.606C74.2265 103.986 76.709 103.462 77.9122 101.609L99.2795 68.7103C99.5765 68.253 99.0313 67.7182 98.5798 68.0239L66.2259 89.9315Z"
        fill="#F0F3FF"
      />
      <path
        d="M36.9006 87.1306C34.7465 87.5144 33.2825 89.5642 33.8244 91.6841C34.6601 94.9536 35.8728 98.1666 37.4759 101.261C38.4932 103.224 40.974 103.755 42.8267 102.552L75.728 81.1882C76.1852 80.8913 75.9047 80.181 75.368 80.2766L36.9006 87.1306Z"
        fill="#F0F3FF"
      />
      <path
        d="M111.932 61.1286C110.865 61.4145 110.232 62.5112 110.518 63.5781L120.493 100.807C121.065 102.941 123.274 104.241 125.355 103.506C145.842 96.2706 158.089 75.3054 154.33 53.9059C153.948 51.7301 151.735 50.4635 149.601 51.0353L111.932 61.1286Z"
        fill="#E5EBFF"
      />
    </svg>
  ),
};

export const chartNotBar = {
  viewBox: "0 0 328 190",
  data: (
    <svg width="328" height="190" viewBox="0 0 328 190" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="12" y="183" width="316" height="1" fill="#E0E1E6" />
      <path
        d="M4.35547 188.141C6.30078 188.141 7.4668 186.459 7.4668 183.775V183.764C7.4668 181.08 6.30078 179.404 4.35547 179.404C2.41016 179.404 1.25586 181.08 1.25586 183.764V183.775C1.25586 186.459 2.41016 188.141 4.35547 188.141ZM4.35547 187.221C3.06641 187.221 2.31641 185.896 2.31641 183.775V183.764C2.31641 181.643 3.06641 180.33 4.35547 180.33C5.64453 180.33 6.40625 181.643 6.40625 183.764V183.775C6.40625 185.896 5.64453 187.221 4.35547 187.221Z"
        fill="#B0B1B7"
      />
      <rect x="12" width="1" height="184" fill="#E0E1E6" />
    </svg>
  ),
};

export const chartNotPie = {
  viewBox: "0 0 196 196",
  data: (
    <svg width="196" height="196" viewBox="0 0 196 196" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M98 196C152.124 196 196 152.124 196 98C196 43.8761 152.124 0 98 0C43.8761 0 0 43.8761 0 98C0 152.124 43.8761 196 98 196ZM98 147C125.062 147 147 125.062 147 98C147 70.938 125.062 49 98 49C70.938 49 49 70.938 49 98C49 125.062 70.938 147 98 147Z"
        fill="#F7F7F7"
      />
    </svg>
  ),
};

export const Warning = {
  viewBox: "0 0 16 16",
  data: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#FFC561" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V4ZM8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
        fill="white"
      />
    </svg>
  ),
};

export const GlobalError = {
  viewBox: "0 0 105 153",
  data: (
    <svg width="105" height="153" xmlns="http://www.w3.org/2000/svg">
      <g id="kawaii-file">
        <g id="kawaii-file__body" fillRule="nonzero">
          <path
            d="M14.938 0C7.24 0 .998 6.24.998 13.938v125.124C1 146.76 7.24 153 14.938 153h76.124c7.698 0 13.939-6.24 13.939-13.938V35.569c0-.457-.183-.895-.505-1.218L70.65.504"
            id="kawaii-file__shape"
            fill="#72CEFF"
          />
          <path
            d="M105,34.8555 L95.954,34.8555 C95.961,35.1885 95.979,35.5195 95.979,35.8545 L95.979,138.9965 C95.979,146.7255 89.648,152.9895 81.836,152.9895 L90.927,152.9895 C98.739,152.9895 105.07,146.7255 105.07,138.9965 L105.07,35.8545 C105.07,35.5215 105.066,35.1885 105.059,34.8555 L105,34.8555 Z"
            id="kawaii-file__shadow"
            fill="#000"
            opacity=".1"
          />
          <path
            id="kawaii-file__fold"
            fill="#000"
            opacity=".2"
            d="M70.1445,0 L70.1445,22.641 C70.1445,29.387 75.6135,34.855 82.3595,34.855 L104.9995,34.855 L70.1445,0"
          />
        </g>
        <g id="kawaii-face" transform="translate(20 66)">
          <defs>
            <path
              d="M1.45656876,3.14684877 C1.45656876,3.14684877 1.45656876,3.14684877 1.45656876,3.14684877 L0,3.14685315 C0,2.31818182 0.346033696,1.50734266 0.949429952,0.922027972 C1.55390756,0.335664336 2.38979521,0 3.2440659,0 L25.9525272,0 C26.8067979,0 27.6416041,0.335664336 28.2460818,0.922027972 C28.8505594,1.50734266 29.1965931,2.31818182 29.1965931,3.14685315 C29.1890236,5.85734266 28.240675,8.44825175 26.7127199,10.6814685 C25.1771954,12.9104895 23.0317865,14.8122378 20.4040931,16.0227273 C18.6544603,16.8251748 16.6809868,17.3087413 14.5982965,17.3076923 C11.4666916,17.3076923 8.61299495,16.2241259 6.33025392,14.5951049 C4.0399434,12.9587413 2.264358,10.779021 1.16245695,8.33811189 C0.431460764,6.70909091 0.0010813553,4.95314685 0,3.14685315 L1.45656896,3.14685315 Z"
              id="kawaii-face__path-1"
            />
          </defs>
          <g id="kawaii-face__mouth" transform="translate(18.000000, 16.000000)">
            <path
              d="M6,1.9999998 C6.00066667,3.14799969 6.26599997,4.26466625 6.7166666,5.29933281 C7.39599986,6.85066599 8.49066642,8.23599919 9.90199962,9.27666575 C11.3099995,10.311999 13.0693326,10.9999989 14.9999991,10.9999989 C16.283999,11.0006656 17.5006655,10.6939989 18.5793321,10.1833323 C20.1993319,9.41466574 21.5219985,8.20599919 22.468665,6.788666 C23.4106649,5.36999947 23.9953316,3.72333297 23.9999982,1.9999998 C23.9999982,0.895333245 23.104665,7.10542736e-15 21.9999984,7.10542736e-15 C20.8953319,7.10542736e-15 19.9999986,0.895333245 19.9999986,1.9999998 C20.0006653,2.51933308 19.8739986,3.11066636 19.6166653,3.7006663 C19.233332,4.58733288 18.5526654,5.4513328 17.7299988,6.0519994 C16.9033323,6.65733268 15.9686657,6.99999931 14.9999991,6.99999931 C14.3513325,6.99999931 13.7259992,6.84799932 13.1299993,6.56666602 C12.2373327,6.14866606 11.4226661,5.4193328 10.8599995,4.57066622 C10.2919996,3.7246663 9.99533294,2.77733306 9.99999961,1.9999998 C9.99999961,0.895333245 9.10466636,7.10542736e-15 7.9999998,7.10542736e-15 C6.89533325,7.10542736e-15 6,0.895333245 6,1.9999998"
              id="kawaii-face__mouth__sad"
              fill="#000000"
              transform="translate(14.999999, 5.500000) scale(1, -1) translate(-14.999999, -5.500000)"
            />
          </g>
          <g id="kawaii-face__blush" transform="translate(0.000000, 15.000000)" fill="#000000" opacity="0.2">
            <circle id="Oval" cx="3" cy="3" r="3" />
            <circle id="Oval" cx="63" cy="3" r="3" />
          </g>
          <g id="kawaii-face__eyes" transform="translate(2.000000, 0.000000)" fill="#000000">
            <g id="kawaii-face__eyes__ko" transform="translate(1.500000, 1.000000)" fillRule="nonzero">
              <path
                d="M52.9142136,5.03553391 L50.4393398,2.56066017 C49.8535534,1.97487373 49.8535534,1.02512627 50.4393398,0.439339828 C51.0251263,-0.146446609 51.9748737,-0.146446609 52.5606602,0.439339828 L55.0355339,2.91421356 L57.5104076,0.439339828 C58.0961941,-0.146446609 59.0459415,-0.146446609 59.631728,0.439339828 C60.2175144,1.02512627 60.2175144,1.97487373 59.631728,2.56066017 L57.1568542,5.03553391 L59.631728,7.51040764 C60.2175144,8.09619408 60.2175144,9.04594155 59.631728,9.63172798 C59.0459415,10.2175144 58.0961941,10.2175144 57.5104076,9.63172798 L55.0355339,7.15685425 L52.5606602,9.63172798 C51.9748737,10.2175144 51.0251263,10.2175144 50.4393398,9.63172798 C49.8535534,9.04594155 49.8535534,8.09619408 50.4393398,7.51040764 L52.9142136,5.03553391 Z"
                id="Cross"
              />
              <path
                d="M2.91421356,5.03553391 L0.439339828,2.56066017 C-0.146446609,1.97487373 -0.146446609,1.02512627 0.439339828,0.439339828 C1.02512627,-0.146446609 1.97487373,-0.146446609 2.56066017,0.439339828 L5.03553391,2.91421356 L7.51040764,0.439339828 C8.09619408,-0.146446609 9.04594155,-0.146446609 9.63172798,0.439339828 C10.2175144,1.02512627 10.2175144,1.97487373 9.63172798,2.56066017 L7.15685425,5.03553391 L9.63172798,7.51040764 C10.2175144,8.09619408 10.2175144,9.04594155 9.63172798,9.63172798 C9.04594155,10.2175144 8.09619408,10.2175144 7.51040764,9.63172798 L5.03553391,7.15685425 L2.56066017,9.63172798 C1.97487373,10.2175144 1.02512627,10.2175144 0.439339828,9.63172798 C-0.146446609,9.04594155 -0.146446609,8.09619408 0.439339828,7.51040764 L2.91421356,5.03553391 Z"
                id="Cross"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
};
